import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesIcons from './components/ServicesIcons';
import TrustBar from './components/TrustBar';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-900">
      <Navbar />
      <main className="flex-grow pt-16">
        <HeroSection />
        <ServicesIcons />
        <TrustBar />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
